import React from 'react'
import SubmitButton from './SubmitButton'
import Input from './Input'
import { Message } from '../../locale/Message'

class ChangeAliasForm extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      value: props.customer.alias,
      isLoading: false
    }
  }

  onValueChange = (event) => this.setState({ value: event.target.value })

  changeAlias = () => {
    const { customer, changeAlias, lang } = this.props
    this.setState({ isLoading: true, error: null })
    changeAlias({
      customerAlias: this.state.value,
      bin: customer.bin,
      onSuccess: () => this.setState({ isLoading: false, error: null }),
      onFailure: () => this.setState({ isLoading: false, error: Message.server_error[lang] })
    })
  }

  render() {
    const { customer, index, lang } = this.props
    const { value, isLoading, error } = this.state
    return (
      <article>
        {index !== 0 && <hr />}
        <h5 className="title  text-uppercase">{Message.bin[lang]}: {customer.bin}</h5>
        <p className="t2 mb-4">
          <span className="t3 t-bold">{Message.companyFullName[lang]}</span>
          <br />{customer.customerName}
        </p>
        <Input
          className='password'
          label={Message.companyShortName[lang]}
          type='text'
          value={value}
          id={customer.bin}
          placeholder={Message.enterAlias[lang]}
          error={error}
          onInputChange={this.onValueChange}
        />
        <SubmitButton
          error={error}
          onSubmit={this.changeAlias}
          disabled={value === customer.alias}
          isLoading={isLoading}
          text={Message.save[lang]}
        />
      </article>
    )
  }

}

export default ChangeAliasForm